import React, { useEffect, useState } from "react";
import curriculumService from "../../services/curriculum.service";
import * as Yup from "yup";
import userService from "../../services/user.service";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";

import Swal from "sweetalert2";

const EditUser = (props: any) => {
  const { user } = props;
  // for Modal   ////////////////////////////////////
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [curriAll, setCurriAll] = useState([]);
  // console.log(curriAll);

  const LocalUser = JSON.parse(localStorage.getItem("user") ?? "false");
  const level1 = curriAll.filter((x: any) => x.level === "ป.โท");
  const level2 = curriAll.filter((x: any) => x.level === "ป.ตรี");
  const level3 = curriAll.filter((x: any) => x.level === "ปวส.");
  const level4 = curriAll.filter((x: any) => x.level === "ปวช.");
  const level5 = curriAll.filter((x: any) => x.level === "ป.บัณฑิต");
  // console.log(LocalUser.role.name === "Admin");

  const [disableCurri] = useState(
    LocalUser.role.name === "Admin" ? false : true
  );

  useEffect(() => {
    (async () => {
      await curriculumService.getAll().then((res) => {
        setCurriAll(res.data);
      });
    })();
  }, []);

  const RegisterSchema = Yup.object().shape({
    username: Yup.string().required("กรอกชื่อผู้ใช้ด้วยครับ"),
    firstName: Yup.string().required("อย่าลืม! กรอกชื่อด้วยครับ"),
    lastName: Yup.string().required("อย่าลืม! กรอกนามสกุลด้วยครับ"),
    tel: Yup.string().required("กรอกเบอร์โทรด้วยครับ"),
    email: Yup.string()
      .email("กรุณาระบุ Email ให้ถูกต้องด้วยครับ")
      .required("กรอก E-Mail ด้วยครับ"),
    // curriculum: Yup.array().required("เลือกหลักสูตร อย่างน้อย 1 หลักสูตรครับ"),
    curriculum: Yup.array()
      .min(1, "เลือกหลักสูตร อย่างน้อย 1 หลักสูตรครับ")
      .required("เลือกหลักสูตร อย่างน้อย 1 หลักสูตรครับ"),
  });

  const onSubmit = async (values: any) => {
    // console.log(values);
    await userService
      .updateUser(user.id, values)
      .then(() => {
        // console.log("สำเร็จ");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          window.location.reload();
        });
        // window.location.reload();
      })
      .catch(() => {
        // console.log("ไม่สำเร็จครับผม");
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-secondary"
        onClick={handleShow}
      >
        <i className="bi bi-pencil-square"></i> แก้ไข
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            แก้ไขข้อมูลผู้ใช้
          </Modal.Title>
        </Modal.Header>

        <Formik
          validationSchema={RegisterSchema} //กำหนด validation Schema
          initialValues={{
            username: user.username,
            firstName: user.firstName,
            lastName: user.lastName,
            tel: user.tel,
            email: user.email,
            curriculum: user.curriculum.map((i: any) => `${i.id}`),
          }}
          onSubmit={onSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col">
                    <label htmlFor="Username" className="form-label">
                      Username
                    </label>
                    <Field
                      type="text"
                      disabled
                      className={`form-control ${
                        touched.username
                          ? errors.username
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="username"
                    />
                    <ErrorMessage
                      name="username"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="firstName" className="form-label">
                      ชื่อ
                    </label>
                    <Field
                      type="text"
                      className={`form-control ${
                        touched.firstName
                          ? errors.firstName
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="firstName"
                      // placeholder="1234 Main St"
                    />
                    <ErrorMessage
                      name="firstName"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="lastName" className="form-label">
                      นามสกุล
                    </label>
                    <Field
                      type="text"
                      className={`form-control ${
                        touched.lastName
                          ? errors.lastName
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="lastName"
                      // placeholder="1234 Main St"
                    />
                    <ErrorMessage
                      name="lastName"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="tel" className="form-label">
                      เบอร์โทร
                    </label>
                    <Field
                      type="text"
                      className={`form-control ${
                        touched.tel
                          ? errors.tel
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="tel"
                      // placeholder="1234 Main St"
                    />
                    <ErrorMessage
                      name="tel"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="email" className="form-label">
                      E-Mail
                    </label>
                    <Field
                      type="text"
                      className={`form-control ${
                        touched.email
                          ? errors.email
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="email"
                      // placeholder="1234 Main St"
                    />
                    <ErrorMessage
                      name="email"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-12">
                    <label
                      htmlFor="curriculum"
                      className="form-label is-invalid"
                    >
                      <b>หลักสูตร</b>
                    </label>
                    <div
                      className={`form-control ${
                        touched.curriculum
                          ? errors.curriculum
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                    >
                      {level1.length > 0 && (
                        <div className="row">
                          <h6>
                            <strong>ป.โท</strong>
                          </h6>
                          {level1.map((curri: any) => {
                            // console.log(curri);
                            return (
                              <div className="col-2" key={curri.id}>
                                <Field
                                  type="checkbox"
                                  className="form-check-input"
                                  name="curriculum"
                                  value={`${curri.id}`}
                                  disabled={disableCurri}
                                />
                                <label className="form-check-label ms-1">
                                  {curri.shortName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {level5.length > 0 && (
                        <div className="row">
                          <h6>
                            <strong>ป.บัณฑิต</strong>
                          </h6>
                          {level5.map((curri: any) => {
                            // console.log(curri);
                            return (
                              <div className="col-2" key={curri.id}>
                                <Field
                                  type="checkbox"
                                  className="form-check-input"
                                  name="curriculum"
                                  value={`${curri.id}`}
                                  disabled={disableCurri}
                                />
                                <label className="form-check-label ms-1">
                                  {curri.shortName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {level2.length > 0 && (
                        <div className="row">
                          <h6>
                            <strong>ป.ตรี</strong>
                          </h6>
                          {level2.map((curri: any) => {
                            // console.log(curri);
                            return (
                              <div className="col-2" key={curri.id}>
                                <Field
                                  type="checkbox"
                                  className="form-check-input"
                                  name="curriculum"
                                  value={`${curri.id}`}
                                  disabled={disableCurri}
                                />
                                <label className="form-check-label ms-1">
                                  {curri.shortName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {level3.length > 0 && (
                        <div className="row">
                          <h6>
                            <strong>ปวส.</strong>
                          </h6>
                          {level3.map((curri: any) => {
                            // console.log(curri);
                            return (
                              <div className="col-2" key={curri.id}>
                                <Field
                                  type="checkbox"
                                  className="form-check-input"
                                  name="curriculum"
                                  value={`${curri.id}`}
                                  disabled={disableCurri}
                                />
                                <label className="form-check-label ms-1">
                                  {curri.shortName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {level4.length > 0 && (
                        <div className="row">
                          <h6>
                            <strong>ปวช.</strong>
                          </h6>
                          {level4.map((curri: any) => {
                            // console.log(curri);
                            return (
                              <div className="col-2" key={curri.id}>
                                <Field
                                  type="checkbox"
                                  className="form-check-input"
                                  name="curriculum"
                                  value={`${curri.id}`}
                                  disabled={disableCurri}
                                />
                                <label className="form-check-label ms-1">
                                  {curri.shortName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <ErrorMessage
                      name="curriculum"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="btn btn-primary">
                  บันทึก
                </button>
                <button type="reset" className="btn btn-warning">
                  ล้าง
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
        {/*  */}
      </Modal>
    </>
  );
};

export default EditUser;
